import { useState } from 'react';
import { styled } from '@mui/system';
import {
  Box,
  Paper,
  Typography,
} from '@mui/material';

import Lightbox from 'react-18-image-lightbox';

const PosterImg = styled('img')({
  width: '100%'
});

export default function PaperSlide(props) {

  const [isLightboxOpen, setLightboxOpen] = useState(false);

  const posterUrl = props.posterData.numero ? 'https://posters-ramdec25-assets.hosting.mariaadelaide.com/' + props.posterData.numero + '.jpg' : props.posterData.url;
  
  return <>
    <Box textAlign="center"  sx={{ margin: '5% 10%'}}>
      <Typography variant="h5">{props.posterData.numero}. {props.posterData.titulo}</Typography>
      <Typography variant="h6">{props.posterData.autor}</Typography>
    </Box>
    { props.posterData.numero || props.posterData.url ?
      <Paper elevation={3} sx={{ margin: '10%', marginBottom: '15%', marginTop: '0%' }}>
        <PosterImg
          data-src={posterUrl}
          className="lazyload"
          alt=""
          onClick={() => setLightboxOpen(true)}
        />
      </Paper>
      :
      <Box sx={{
        position: 'absolute',
        width: '100vw',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 2,
        textAlign: 'center'
      }}>
        Imagem do poster não disponível.
      </Box>
    }

    { isLightboxOpen && (
      <Lightbox
        mainSrc={posterUrl}
        onCloseRequest={() => setLightboxOpen(false)}
      />
    )}
  </>;
}
